import type { TradePreviewData } from '@/pages/ChatbotPage'

interface Props {
  trade: TradePreviewData
}

export function TradePreviewCard({ trade }: Props) {
  const handleCopyDetails = () => {
    const details = [
      `Ticker: ${trade.ticker}`,
      `Strategy: ${trade.strategy}`,
      trade.strike ? `Strike: $${trade.strike}` : null,
      trade.expiration ? `Expiration: ${trade.expiration}` : null,
      trade.premium ? `Premium: $${trade.premium}` : null,
    ].filter(Boolean).join('\n')

    navigator.clipboard.writeText(details)
  }

  return (
    <div className="ml-9 mt-2 max-w-[75%]">
      <div className="rounded-lg border border-[var(--color-accent)]/30 bg-[var(--color-accent)]/5 p-4">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-sm">📋</span>
          <span className="text-xs font-bold text-[var(--color-accent)]">Trade Preview</span>
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs">
          <div>
            <span className="text-[var(--color-text-muted)]">Ticker</span>
            <p className="font-semibold text-[var(--color-text-primary)]">{trade.ticker}</p>
          </div>
          <div>
            <span className="text-[var(--color-text-muted)]">Strategy</span>
            <p className="font-semibold text-[var(--color-text-primary)]">{trade.strategy}</p>
          </div>
          {trade.strike && (
            <div>
              <span className="text-[var(--color-text-muted)]">Strike</span>
              <p className="font-semibold text-[var(--color-text-primary)]">${trade.strike}</p>
            </div>
          )}
          {trade.expiration && (
            <div>
              <span className="text-[var(--color-text-muted)]">Expiration</span>
              <p className="font-semibold text-[var(--color-text-primary)]">{trade.expiration}</p>
            </div>
          )}
          {trade.premium && (
            <div>
              <span className="text-[var(--color-text-muted)]">Premium</span>
              <p className="font-semibold text-green-400">${trade.premium}</p>
            </div>
          )}
        </div>

        <div className="flex gap-2 mt-3 pt-3 border-t border-[var(--color-border)]">
          <button
            onClick={handleCopyDetails}
            className="px-3 py-1.5 text-xs rounded bg-[var(--color-accent)] text-white hover:opacity-90 transition-opacity"
          >
            📋 Copy Details
          </button>
          <a
            href="/portfolio-manager/recommendations"
            className="px-3 py-1.5 text-xs rounded border border-[var(--color-border)] text-[var(--color-text-muted)] hover:border-[var(--color-accent)] hover:text-[var(--color-accent)] transition-colors"
          >
            View Recommendations →
          </a>
        </div>
      </div>
    </div>
  )
}
